<template>
  <b-modal
    :active.sync="active"
    has-modal-card
  >
    <section>
      <div class="modal-bg">
        <b-field v-if="isEdit" :label="`Изменить ${form.id} Отмена`"></b-field>
        <b-field>
          <b-input placeholder="Номер картки" v-model="form.number" v-mask="'####'"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Имя" v-model="form.name"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="телефон" v-model="form.phone" v-mask="'0#########'"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Бонусы" v-model="form.bonuses"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Коментарий" v-model="form.comment"></b-input>
        </b-field>
        <!-- <b-field>
          <b-datepicker
            :month-names="$store.state.month"
            :first-day-of-week="1"
            v-model="form.birthday"
            placeholder="Дата народження"
            icon="calendar-today"
          >
          <button class="button is-danger"
              @click="birthday = null">
              <b-icon icon="close"></b-icon>
              <span>видалити</span>
          </button>
          </b-datepicker>
        </b-field> -->
        <b-field>
          <b-switch
            v-model="form.en"
            :true-value="0"
            :false-value="1"
          >
            {{ form.en === 1 ? 'EN' : 'UA' }}
          </b-switch>
        </b-field>

        <div class="control">
          <button class="button is-link" @click="submit">отправить</button>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  props: ['card'],

  data () {
    return {
      form: {
        en: 1,
        bonuses: 0,
        ...this.card,
        number: this.card.id || ''
      }
    }
  },

  computed: {
    active: {
      get () {
        return true
      },

      set () {
        this.close()
      }
    },

    isEdit () {
      return Boolean(this.form.id) == true
    },

    isNew () {
      return Boolean(this.form.id) == false
    },

    isValidData () {
      if (this.isNew && this.form.number.length !== 4) {
        return false
      }

      return (
        this.form.name.length > 3 &&
        this.form.phone.length === 10
      )
    }
  },

  methods: {
    async submit () {
      if (this.isEdit) {
        return await this.editCart()
      }

      return await this.addCard()
    },

    async addCard() {
      if (!this.isValidData) {
        this.showSnackBar("Проверте данные!");

        return
      }

      try {
        await this.$store.dispatch('submitCart', {
          ...this.form,
          lang: this.form.en,
          number: `${this.form.number}`,
          bonuses: Number(this.form.bonuses || 0)
        })

        this.close()
      } catch {
        this.showSnackBar("Что-то не так");
      }
    },

    async editCart() {
      if (!this.isValidData) {
        this.showSnackBar("Проверте данные!");

        return
      }

      try {
        await this.$store.dispatch('submitEditCart', {
          ...this.form,
          lang: this.form.en,
          number: this.form.id,
          bonuses: Number(this.form.bonuses || 0)
        })

        this.close()
      } catch {
        this.showSnackBar("Что-то не так");
      }
    },

    showSnackBar(text) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message: text,
        type: "is-warning",
        position: "is-bottom",
        actionText: "Ок"
      });
    },

    close () {
      this.$emit('refresh')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  //
</style>
